import { Device, until } from '@helpers/media';
import { clamp } from '@helpers/utils';
import { withMotionMax } from '@hoc/withMotionMax';
import useMedia from '@hooks/useMedia';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import TabbedSignpostCard from '@stories/Components/Cards/TabbedSignpostCard/TabbedSignpostCard';
import * as React from 'react';
import S from './TabbedSignposts.styles';
const TabbedSignposts = (props) => {
    const paddingOffset = useMedia([until(Device.TabletLarge)], [24], 0);
    const [active, setActive] = React.useState(0);
    const tabRef = React.useRef([]);
    if (props.groups.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, { translations: props.translations, background: props.backgroundColor },
        React.createElement(S.Wrapper, null,
            React.createElement(S.TopArea, null,
                React.createElement(S.Title, null, props.title),
                React.createElement(S.TabWrapper, { "data-hidden": props.groups.length === 1 },
                    React.createElement(S.Tabs, { role: "tablist" }, props.groups.map((group, i) => (React.createElement(React.Fragment, { key: `${group.groupTitle}-button` },
                        React.createElement(S.TabButton, { id: group.groupTitle, ref: (el) => (tabRef.current[i] = el), role: "tab", "data-type": group.theme, "aria-selected": active === i, onClick: () => {
                                if (active !== i) {
                                    setActive(i);
                                }
                            }, onFocus: () => setActive(i), tabIndex: props.groups.length === 1 || active !== i ? -1 : undefined, onKeyDown: (event) => {
                                const nextIndex = i === props.groups.length - 1 ? 0 : clamp(i + 1, props.groups.length - 1);
                                const prevIndex = i === 0 ? props.groups.length - 1 : clamp(i - 1, props.groups.length - 1);
                                switch (event.key) {
                                    case 'ArrowRight':
                                    case 'ArrowDown':
                                        event.preventDefault();
                                        event.stopPropagation();
                                        tabRef.current[nextIndex]?.focus();
                                        break;
                                    case 'ArrowLeft':
                                    case 'ArrowUp':
                                        event.preventDefault();
                                        event.stopPropagation();
                                        tabRef.current[prevIndex]?.focus();
                                        break;
                                    case 'Home':
                                        tabRef.current[0]?.focus();
                                        break;
                                    case 'End':
                                        tabRef.current[props.groups.length - 1]?.focus();
                                        break;
                                    default:
                                        break;
                                }
                            } }, group.groupTitle))))))),
            props.groups.map((group, i) => (React.createElement(S.SectionTab, { key: `${group.groupTitle}-wrapper`, role: "tabpanel", "aria-labelledby": group.groupTitle, "data-active": active === i, "data-type": group.theme },
                React.createElement(S.SixColGrid, { mobileCarousel: group.cards.length > 2, paddingOffset: paddingOffset, carouselType: group.theme }, group.cards.map((card, index) => (React.createElement(TabbedSignpostCard, { key: index, typeTheme: group.theme, ...card, parentTheme: props.backgroundColor ?? 'white', translations: props.translations })))),
                group.cta && (React.createElement(S.LinkArea, null,
                    React.createElement(LinkButton, { buttonType: group.theme === 'mortgages' ? 'default' : group.theme ?? 'default', href: group.cta.url, target: group.cta.target }, group.cta.text)))))))));
};
export default withMotionMax(TabbedSignposts);
